import Script from 'next/script';

const GTM_CONTAINER_ID = process.env.NEXT_PUBLIC_GTM_CONTAINER_ID;
const GTM_AUTH = process.env.NEXT_PUBLIC_GTM_AUTH;
const GTM_PREVIEW = process.env.NEXT_PUBLIC_GTM_PREVIEW;

type GoogleTagManagerScriptProps = {
  variant?: string | null;
};

function getGtmUrl() {
  if (!GTM_CONTAINER_ID) return null;

  const baseUrl = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`;

  if (GTM_AUTH && GTM_PREVIEW) {
    return `${baseUrl}&gtm_auth=${GTM_AUTH}&gtm_preview=${GTM_PREVIEW}&gtm_cookies_win=x`;
  }

  return baseUrl;
}

export default function GoogleTagManagerScript({
  variant,
}: GoogleTagManagerScriptProps) {
  const gtmUrl = getGtmUrl();

  if (!gtmUrl) return null;

  return (
    <Script id="gtm-init" strategy="afterInteractive">
      {`
        window.dataLayer = window.dataLayer || [];
        if ('${variant || ''}') {
          window.dataLayer.push({
            'event': 'ab_test_variant',
            'abTestVariant': '${variant}'
          });
        }
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        '${gtmUrl}'+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTM_CONTAINER_ID}');
      `}
    </Script>
  );
}
